import { TEST_IDS } from '@hapana/shared/constants/test-ids.constants'

import { ROUTES } from '../../app.constants'

import { PENDING_ITEMS_KEY } from './pending-items.utils'

export const PENDING_ITEMS_IDS = TEST_IDS.core.pendingItems

export const buildPendingItemsKey = (leaf: string): string => `${PENDING_ITEMS_KEY}.${leaf}`

export const PENDING_ITEMS_SESSION_PATH = `/${ROUTES.publicPendingItems.children.session.path}`
export const PENDING_ITEMS_RECEIPT_SESSION_PATH = `/${ROUTES.publicPendingItems.children.receiptSession.path}`
export const CORE_HOME_PATH = '/'
export const STAFF_LOGIN_PATH = `/${ROUTES.login.path}`

export const TERMINAL_TEST_IDS = {
  SUPERSEDED: PENDING_ITEMS_IDS.stateSuperseded,
  EXPIRED: PENDING_ITEMS_IDS.stateExpired,
  CANCELLED: PENDING_ITEMS_IDS.stateCancelled,
  LOCKED: PENDING_ITEMS_IDS.stateLocked,
  FAILED: PENDING_ITEMS_IDS.stateFailed,
} as const
